import { render } from "./gradesheetbatch.vue?vue&type=template&id=2fc09447"
import script from "./gradesheetbatch.vue?vue&type=script&lang=js"
export * from "./gradesheetbatch.vue?vue&type=script&lang=js"

import "./gradesheetbatch.vue?vue&type=style&index=0&id=2fc09447&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__